module.exports = __webpack_public_path__ + "media/images/front/icon-sort-cdbaaaffc58bb2342c469e7004e40610.svg";